export const DOWNLOAD_PROFORMA_TEMPLATE_PENDING = '[PROFORMA_UPLOAD][DOWNLOAD] Download PROFORMA Template pending';
export const DOWNLOAD_PROFORMA_TEMPLATE_SUCCESS = '[PROFORMA_UPLOAD][DOWNLOAD] Download PROFORMA Template success';
export const DOWNLOAD_PROFORMA_TEMPLATE_FAILURE = '[PROFORMA_UPLOAD][DOWNLOAD] Download PROFORMA Template failure';

export const GET_UPLOADED_PROFORMAS_SUCCESS = '[PROFORMA_UPLOAD][GET] get Uploaded PROFORMAs success';
export const GET_UPLOADED_PROFORMAS_FAILURE = '[PROFORMA_UPLOAD][GET] get Uploaded PROFORMAs failure';

//PROFORMA Filter
export const CLEAR_FILTER = 'PROFORMA upload clear filter';
export const ON_CHANGE = 'PROFORMA upload on change';
export const ON_CHANGE_DATE = 'PROFORMA upload on change date';

// modal
export const SHOW_FILTER_MODAL = '[PROFORMA_UPLOAD][FILTERS] toggle Modal';
// export const HYDRATE_PROFORMAS = '[PROFORMA_UPLOAD][DOCUMENTS] hydrate PROFORMA documents';
// export const HYDRATE_PROFORMAS_FILTERS = '[PROFORMA_UPLOAD][FILTERS] hydrate filters';
export const APPLY_PROFORMAS_FILTERS = '[PROFORMA_UPLOAD][FILTERS] apply filters';
export const APPLY_PROFORMAS_FILTERS_SUCCESS = '[PROFORMA_UPLOAD][FILTERS] apply filters success';
export const APPLY_PROFORMAS_FILTERS_FAILURE = '[PROFORMA_UPLOAD][FILTERS] apply filters failure';
export const GET_FILTERS_SUCCESS = '[PROFORMA_UPLOAD][FILTERS] get PROFORMA filters';

//PROFORMA upload

export const PROFORMA_UPLOAD_PENDING = '[PROFORMA_UPLOAD][PENDING] PROFORMA upload pending';
export const PROFORMA_UPLOAD_FAILURE = '[PROFORMA_UPLOAD][FAILURE] PROFORMA upload failure';
export const SET_IMPORT_JOB_ID = '[PROFORMA_UPLOAD][UPLOAD] set import job id';
export const RESET_PROFORMA_UPLOAD = '[PROFORMA_UPLOAD][RESET] reset PROFORMA upload ';
export const SAVE_PROFORMA_UPLOAD = '[PROFORMA_UPLOAD][SAVE] save PROFORMA upload ';
